import React from 'react';

export function useSyncExecution (initialState?: boolean) {
    const canExecuteRef = React.useRef(initialState === true);

    const lock = React.useCallback(() => {
        canExecuteRef.current = false;
    }, []);

    const free = React.useCallback(() => {
        canExecuteRef.current = true;
    }, []);

    const canExecute = React.useCallback(() => {
        return canExecuteRef.current;
    }, []);

    return React.useMemo(() => ({
        lock, free, canExecute
    }), [canExecute, free, lock]);
}